import status from '../../functions/Status/status.dictionaries'

export const purchasedStatuses = [
  status.deliveryStatus.purchasedByTraveler,
  status.deliveryStatus.purchasedByAdmin,
  status.deliveryStatus.purchasedByAgentAdmin
]

// Purchased by Admin (excludes traveler purchases)
export const purchasedByAdminStatuses = [
  status.deliveryStatus.purchasedByAdmin,
  status.deliveryStatus.purchasedByAgentAdmin
]

export const deliveredToTravelerAddressStatuses = [
  status.deliveryStatus.confirmedDeliveredToTravelerAddressByAdmin,
  status.deliveryStatus.confirmedDeliveredToTravelerAddressByAgentAdmin,
  status.deliveryStatus.confirmedReceivedByTraveler,
  status.deliveryStatus.readyForDropoffAtLocker
]

export const deliveredToShopperStatuses = [
  status.deliveryStatus.confirmedDeliveredToShopperByTraveler,
  status.deliveryStatus.confirmedDeliveredToShopperByShopper,
  status.deliveryStatus.confirmedDeliveredToShopperByAdmin,
  status.deliveryStatus.confirmedDeliveredToShopperByAgentAdmin,
  status.deliveryStatus.awaitingShopperPickupFromLocker,
  status.deliveryStatus.confirmedDeliveredToShopperViaLocker
]

export enum FilterStatus {
  readyForPurchase = 'ready_for_purchase',
  purchased = 'purchased',
  deliveredToTravelerAddress = 'delivered_to_traveler_address',
  deliveredToShopper = 'delivered_to_shopper'
}

/// The tabs, in the order they are rendered. `readyToPurchaseTabIndex` is an
/// index into this, so the dashboard no longer needs its own switch to work out
/// which list a tab is showing.
export const purchaseTableTabs = [
  FilterStatus.readyForPurchase,
  FilterStatus.purchased,
  FilterStatus.deliveredToTravelerAddress,
  FilterStatus.deliveredToShopper
] as const

/// The `status` query a tab sends, which is ALSO the key its results are stored
/// under in the getPurchaseReadyItems slice. Both callers must derive it from
/// here: a tab that reads a different key than it wrote would render another
/// tab's rows, which is exactly the bug this replaced.
export const apiStatusForFilter = (filterStatus?: FilterStatus): string => {
  switch (filterStatus) {
    case FilterStatus.purchased:
      return purchasedByAdminStatuses.join(',')
    case FilterStatus.deliveredToTravelerAddress:
      return deliveredToTravelerAddressStatuses.join(',')
    case FilterStatus.deliveredToShopper:
      return deliveredToShopperStatuses.join(',')
    case FilterStatus.readyForPurchase:
    default:
      return status.itemRequestStatus.readyForPurchase
  }
}

export const apiStatusForTabIndex = (tabIndex: number): string =>
  apiStatusForFilter(purchaseTableTabs[tabIndex] ?? FilterStatus.readyForPurchase)
